import citiesQuery from '@/services/gql/types/City/queries/citiesGrid.gql'
import routesQuery from '@/services/gql/types/Routes/queries/routesGrid.gql'
import audioguidesQuery from '@/services/gql/types/Audioguides/queries/audioguidesGrid.gql'
import eventCategoryQuery from '@/services/gql/types/EventCategories/queries/eventCategories.gql'
import eventQuery from '@/services/gql/types/Events/queries/eventsGrid.gql'
import pagesQuery from '@/services/gql/types/Pages/queries/pagesGrid.gql'
import blogCategoriesQuery from '@/services/gql/types/BlogCategory/queries/blogCategoriesGrid.gql'
import blogPostsQuery from '@/services/gql/types/BlogPosts/queries/blogPostsGrid.gql'
import placeCategoriesQuery from '@/services/gql/types/PlaceCategory/queries/placeCategories.gql'
import placesQuery from '@/services/gql/types/Places/queries/placesGrid.gql'
import hotelsQuery from '@/services/gql/types/Hotels/queries/hotelsGrid.gql'

export default {
  default: eventQuery,
  cities: citiesQuery,
  routes: routesQuery,
  audioguides: audioguidesQuery,
  eventCategories: eventCategoryQuery,
  events: eventQuery,
  pages: pagesQuery,
  blogCategories: blogCategoriesQuery,
  blogPosts: blogPostsQuery,
  placeCategories: placeCategoriesQuery,
  places: placesQuery,
  hotels: hotelsQuery
}
